module.exports = __webpack_public_path__ + "img/青山万佳.9a7f5f7c.jpg";